import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { getOrCreateClientId } from '@evorait/pace-core';

/**
 * Adds x-pace-device-id to every request. Only PACE has a device-lock concept on the
 * backend, so this is registered in apps/pace only — PACE for Authors and PACE Forms for
 * Factory Installation don't have a device id at all.
 */
@Injectable()
export class DeviceIdInterceptor implements HttpInterceptor {
    public intercept<T>(req: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
        const modifiedReq = req.clone({
            setHeaders: {
                'x-pace-device-id': getOrCreateClientId(),
            },
        });

        return next.handle(modifiedReq);
    }
}
